module.exports = __webpack_public_path__ + "img/Porsche_wordmark_white_rgb.cde340a8.svg";